import React from 'react';

import styled from 'styled-components';
import Sidebar from './Components/Sidebar/Sidebar';
import Navbar from './Components/Navbar/Navbar';
import MainContent from './Components/Main/MainContent';
import Notifications from '../Notifications/Notifications';

const MainLayout = styled.div`
  display: flex;
  height: 100vh;
  overflow: auto;
  min-width: 600px;
`;

const Main = styled.div`
  display: flex;
  flex-direction: column;
  overflow: auto;
  background: #eeeeee;
  flex: 1;
`;

const Layout = ({ children, showOpenCashDrawer }) => {
  return (
    <MainLayout>
      <Notifications/>
      <Sidebar />
      <Main>
        <Navbar showOpenCashDrawer={showOpenCashDrawer} />
        <MainContent>{children}</MainContent>
      </Main>
    </MainLayout>
  );
};

export default Layout;
